// extracted by mini-css-extract-plugin
module.exports = {"repo":"Repository-module--repo--N7uET","repoTitle":"Repository-module--repoTitle--3oZZw","meta":"Repository-module--meta--35l0J"};